
/**
 * 判断 Puppy CAD 内核 面是否使用反向拓扑方向。
 *
 * 设计说明：
 * 1. Puppy CAD 内核 曲面的参数方向只描述底层几何，实体面的外向语义由 `Orientation()` 补充；
 * 2. 拉伸体两个端面可以具有相同的参数曲面法向，其中背面通过 `TopAbs_REVERSED` 表示反向；
 * 3. 网格化与权威拓扑快照必须共用该判断，避免渲染法向和业务拓扑法向出现相反结论。
 *
 * @param puppy Puppy CAD 内核 实例。
 * @param faceShape 待读取方向的 Puppy CAD 内核 面。
 * @returns 面方向是否为 `TopAbs_REVERSED`。
 */
export function isPuppyFaceReversed(
  puppy: {
    TopAbs_Orientation?: {
      TopAbs_REVERSED?: unknown;
    };
  },
  faceShape: unknown,
): boolean {
  const orientationResolver = (faceShape as { Orientation?: () => unknown } | null)?.Orientation;
  const reversedOrientation = puppy.TopAbs_Orientation?.TopAbs_REVERSED;
  if (typeof orientationResolver !== 'function' || reversedOrientation === undefined) {
    return false;
  }

  // `Orientation()` 依赖当前 Puppy CAD 内核 面作为调用上下文，不能脱离对象直接执行。
  return orientationResolver.call(faceShape) === reversedOrientation;
}
